import { CompanyModel } from "../../../Utils/Models";
import { Vocabulary } from "../../../Utils/Vocabulary";

export const companyReportColumn = (companies: CompanyModel[]) => [
  {
    name: "productName",
    label: Vocabulary.product,
    options: {
      setCellProps: () => ({
        style: {
          position: "sticky",
          left: 0,
          background: "#fff",
          zIndex: 1000,
        },
      }),
    },
  },
  ...(companies.map((company: any) => ({
    name: company.name,
    label: company.name,
    options: {
      customBodyRender: (value: any) => value ?? 0,
    },
  })) ?? []),
];
